/**
 * Vanity Assembly Module
 * Shared between cloud functions and web app
 */

const { assembleVanity } = require('./assembleVanity');
const { emitVanityLinks } = require('./emitVanityLinks');
const {
  attachVanityLinks,
  attachVanityLinksForGroups,
} = require('./attachVanityLinks');
const {
  repositionVanityAccessories,
} = require('./repositionVanityAccessories');
const { calculateMirrorWallSpace } = require('./calculateMirrorWallSpace');
const {
  VANITY_DIMENSIONS,
  VANITY_STYLE_CONFIG,
  INCHES_TO_METERS,
} = require('./constants');

// placementUtils, wallFixtureCollision, createAccessories, accessoryRules
// exported separately for granular imports
module.exports = {
  assembleVanity,
  emitVanityLinks,
  attachVanityLinks,
  attachVanityLinksForGroups,
  repositionVanityAccessories,
  calculateMirrorWallSpace,
  VANITY_DIMENSIONS,
  VANITY_STYLE_CONFIG,
  INCHES_TO_METERS,
};
